import { render, staticRenderFns } from "./ConfirmChangesModal.vue?vue&type=template&id=e908231a&scoped=true"
import script from "./ConfirmChangesModal.vue?vue&type=script&lang=js"
export * from "./ConfirmChangesModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmChangesModal.vue?vue&type=style&index=0&id=e908231a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e908231a",
  null
  
)

export default component.exports